import { Directive } from '@angular/core';

@Directive({
	selector: 'help-body, help-title, panel-heading, panel-body, card-action, card-title, card-description, suggested-value, current-value'
})
export class EmptyComponent { }
